;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import type { ReactNode } from "react"
import Link from "next/link"
import * as Sentry from "@sentry/nextjs"
import { validateUrl } from "../../lib/url/validateUrl"

export const ContentRichTextLink = ({
  node,
  children,
  ...props
}: {
  node?: { data?: { url?: string; target?: string } }
  children?: ReactNode
  [key: string]: unknown
}) => {
  const url = node?.data?.url || String(props.href || "")
  const { key, ...restProps } = props
  const { valid } = validateUrl(url)

  if (!url || !valid) {
    const errorMessage = `Malformed URL detected in editorial content: "${url}"`
    console.error(errorMessage)
    Sentry.captureException(new Error(errorMessage), {
      level: "warning",
      tags: {
        component: "ContentRichTextLink",
        url_type: "malformed_editorial_link",
      },
      extra: { url, node },
    })
    return (
      <span
        style={{
          color: "inherit",
          textDecoration: "underline",
          cursor: "default",
        }}
        title={`Invalid link: ${url}`}
      >
        {children}
      </span>
    )
  }

  if (url.startsWith("http") || url.startsWith("//")) {
    return (
      <a
        href={url}
        target={node?.data?.target || "_blank"}
        rel="noopener noreferrer"
        key={key as string | undefined}
        {...restProps}
      >
        {children}
      </a>
    )
  }

  return (
    <Link href={url} key={key as string | undefined} {...restProps}>
      {children}
    </Link>
  )
}

export const getContentRichTextComponents = (
  additionalComponents: Record<string, unknown> = {},
) => ({
  hyperlink: ContentRichTextLink,
  ...additionalComponents,
})
